import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import './Dashboard.css';

const MyCourses = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [courses, setCourses] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    // TODO: Implement course data fetching
    const fetchMyCourses = async () => {
      try {
        setLoading(true);
        // const data = await courseService.getMyCourses();
        // setCourses(data);
        setError(null);
      } catch (err) {
        setError('Failed to fetch courses. Please try again later.');
        console.error('Error fetching courses:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchMyCourses();
  }, []);

  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="spinner"></div>
        <p>Loading your courses...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-error">
        <div className="error-content">
          <i className="error-icon fas fa-exclamation-circle"></i>
          <h2>Error Loading Courses</h2>
          <p>{error}</p>
          <button className="retry-button" onClick={() => window.location.reload()}>
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>My Courses</h1>
        {user.role === 'trainer' && (
          <button className="btn btn-primary">
            <i className="fas fa-plus"></i> Create New Course
          </button>
        )}
      </div>

      <div className="dashboard-content">
        <div className="filters-section">
          <div className="search-box">
            <i className="fas fa-search"></i>
            <input type="text" placeholder="Search your courses..." />
          </div>
          <div className="filter-options">
            <select defaultValue="">
              <option value="">All Status</option>
              <option value="in-progress">In Progress</option>
              <option value="completed">Completed</option>
              {user.role === 'trainer' && (
                <>
                  <option value="draft">Draft</option>
                  <option value="published">Published</option>
                </>
              )}
            </select>
            <select defaultValue="">
              <option value="">All Categories</option>
              <option value="programming">Programming</option>
              <option value="design">Design</option>
              <option value="business">Business</option>
            </select>
          </div>
        </div>

        <div className="courses-grid">
          {courses.length === 0 ? (
            <div className="no-data">
              <i className="fas fa-book"></i>
              <h2>No Courses Found</h2>
              <p>
                {user.role === 'trainer' 
                  ? 'Start by creating your first course'
                  : 'Enroll in a course to get started'
                }
              </p>
              {user.role === 'student' && (
                <button className="btn btn-primary">
                  Browse Courses
                </button>
              )}
            </div>
          ) : (
            courses.map(course => (
              <div key={course.id} className="course-card">
                <div className="course-image">
                  <img src={course.thumbnail || '/images/course-default.jpg'} alt={course.title} />
                  {course.progress === 100 && (
                    <div className="completed-badge">
                      <i className="fas fa-check-circle"></i> Completed
                    </div>
                  )}
                </div>
                <div className="course-content">
                  <h3>{course.title}</h3>
                  <p>{course.description}</p>
                  <div className="progress-container">
                    <div className="progress-bar">
                      <div 
                        className="progress" 
                        style={{ width: `${course.progress}%` }}
                      ></div>
                    </div>
                    <span className="progress-text">{course.progress}% Complete</span>
                  </div>
                  <div className="course-footer">
                    <span className={`status-badge ${course.status.toLowerCase()}`}>
                      {course.status}
                    </span>
                    <button className="btn btn-primary">
                      {user.role === 'trainer' ? 'Manage Course' : 'Continue Learning'}
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default MyCourses; 